import '@vaadin/vaadin-overlay';
import { OverlayElement } from '@vaadin/vaadin-overlay';
import { registerStyles, unsafeCSS } from '@vaadin/vaadin-themable-mixin/register-styles.js';
import { customElement } from 'lit/decorators.js';
import { styles as genericOverlayStyles } from './../view/genericOverlay.scss';
import { GenericOverlayEvents } from '../types';

registerStyles('generic-overlay', unsafeCSS(`${genericOverlayStyles}`), { moduleId: 'generic-overlay-styles' });

/**
 * @summary Web Component which extends the Vaadin overlay component, used in gz-generic-overlay
 * It should not be used directly, please use gz-generic-overlay instead.
 * https://cdn.vaadin.com/vaadin-web-components/24.4.0-alpha3/#/elements/vaadin-overlay
 */
@customElement('generic-overlay')
export class GenericOverlayElement extends OverlayElement {
  private static ATTACH_TO_BODY_ATTRIBUTE = 'attachtobody';

  static get is() {
    return 'generic-overlay';
  }

  get attachToBody(): boolean {
    return this.hasAttribute(GenericOverlayElement.ATTACH_TO_BODY_ATTRIBUTE);
  }

  set attachToBody(value: boolean) {
    this.setAttribute(GenericOverlayElement.ATTACH_TO_BODY_ATTRIBUTE, value.toString());
  }

  _attachOverlay(): void {
    if (!this.attachToBody) {
      return;
    }
    this.dispatchEvent(new CustomEvent(GenericOverlayEvents.BEFORE_ATTACH));
    super._attachOverlay();
  }

  _detachOverlay(): void {
    if (!this.attachToBody) {
      return;
    }
    this.dispatchEvent(new CustomEvent(GenericOverlayEvents.BEFORE_DETACH));
    super._detachOverlay();
  }
}
